/* __next_internal_client_entry_do_not_use__ Default auto */ import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
// Global
import { useRef } from 'react';
import { tv } from 'tailwind-variants';
import { withStandardComponentWrapper } from 'helpers/HOC';
import { useScrollElementIntoView } from 'lib/hooks/useScrollElementIntoView';
import PlainTextWrapper from 'helpers/SitecoreWrappers/PlainTextWrapper/PlainTextWrapper';
import { useWatchJumpNavActiveState } from 'helpers/Context/JumpNavContext';
import { PlaceholderWrapper } from 'helpers/SitecoreWrappers/PlaceholderWrapper/PlaceholderWrapper';
import { getTestProps } from 'lib/testing/utils';
import { editingHydrationProps } from 'lib/hooks/useEditingHydrationProps';
import useIsEditing from 'lib/hooks/useIsEditing';
const JumpNavSection = (props)=>{
    const isEditing = useIsEditing();
    const { heading } = props?.fields || {};
    const { uid } = props?.rendering || {};
    const context = props.context || 'desktop';
    const phKey = `custom-section-content`;
    const accordionId = `accordion-${uid}`;
    const accordionItemHeadlineRef = useRef(null);
    const accordionItemBodyRef = useRef(null);
    useScrollElementIntoView(accordionItemHeadlineRef.current, {
        stickyHeaderId: `jumpnav-header-${uid}`,
        animationElement: accordionItemBodyRef.current,
        scrollTargetId: accordionId
    });
    // Update the active
    useWatchJumpNavActiveState(accordionItemHeadlineRef, uid, `jumpnav-header-${uid}`);
    /*
   * Rendering
   */ const { base, headline } = TAILWIND_VARIANTS();
    return /*#__PURE__*/ _createElement("div", {
        className: base(),
        "data-component": "authorable/shared/layout/jump-nav-mobile-accordion-item",
        ...editingHydrationProps(isEditing),
        key: accordionId,
        ref: accordionItemHeadlineRef,
        id: `accordion-${uid}`,
        tabIndex: -1,
        ...getTestProps(`component-jump-nav-section-${props?.rendering?.uid}`)
    }, /*#__PURE__*/ _jsxs("div", {
        ref: accordionItemBodyRef,
        "aria-labelledby": `jumpnav-${context}-${uid}`,
        children: [
            /*#__PURE__*/ _jsx(PlainTextWrapper, {
                className: headline(),
                field: heading,
                tag: "h2",
                id: `jumpnav-header-${uid}`,
                ...getTestProps(`header`)
            }),
            /*#__PURE__*/ _jsx(PlaceholderWrapper, {
                name: phKey,
                rendering: props.rendering,
                ...getTestProps(`placeholder`)
            })
        ]
    }));
};
export const Default = withStandardComponentWrapper(JumpNavSection);
const TAILWIND_VARIANTS = tv({
    slots: {
        base: [
            'overflow-hidden'
        ],
        headline: [
            'items-center',
            'justify-between',
            'font-bold',
            'text-typography-font-size-large',
            'font-typography-font-family-header',
            'text-color-text-text'
        ]
    }
});
